/* tslint:disable */
import { DecisionServiceVersionListDataItem } from "./DecisionServiceVersionListDataItem"

export class DecisionServiceVersionListData {
		ListId: number;

		Items: DecisionServiceVersionListDataItem[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/DecisionServiceVersionListData.ts